var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Confirmation",
    _vm._b(
      {
        attrs: {
          "test-id": _vm.makeTestId("container"),
          titulo: _vm.tituloEstandarOrSobreescrito,
          mensaje: _vm.mensajeEstandarOrSobreescrito,
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacion }
      },
      "Confirmation",
      Object.assign({}, _vm.passthroughProps, _vm.passthroughAttributes),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }